import React from 'react';

interface IMultiResultRow {
  row: any;
  handleExpandedRow: any;
  index: number;
}

const MultiResultRow: React.FC<IMultiResultRow> = ({
  handleExpandedRow,
  row,
  index,
}) => {
  return (
    <div className='screening-results-row'>
      {row?.result && (
        <>
          <div
            className='screening-results-row-default-cell'
            onClick={() => handleExpandedRow(row?.result, index)}
          >
            <div className='screening-results-row-default-cell-inner'>
              <div
                style={{ cursor: 'pointer' }}
                className='screening-results-row-link-cell-text'
              >
                {row?.result?.body?.hits?.hits[0]?.matched_queries[0]}
              </div>
            </div>
          </div>
          <div
            className='screening-results-row-default-cell'
            onClick={() => handleExpandedRow(row?.result, index)}
          >
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {row?.result?.body?.hits?.total?.value}
              </div>
            </div>
          </div>
        </>
      )}
      <div className='screening-results-row-placeholder-cell'>
        <svg
          style={{ cursor: 'pointer' }}
          onClick={() => handleExpandedRow(row?.result, index)}
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
        >
          <path
            d='M15.75 10.5V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H10.5M7.5 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V7.5M11.25 6.75L15.75 2.25M15.75 2.25H11.25M15.75 2.25V6.75M6.75 11.25L2.25 15.75M2.25 15.75H6.75M2.25 15.75L2.25 11.25'
            stroke='var(--text-primary)'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
    </div>
  );
};

export default MultiResultRow;
